import { ArticleHeading1, InlineText1 } from '@cian/ui-kit';
import cx from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingDecorationProps {
  items: React.ReactNode;
  isRedesigned: boolean;
}

export function NewbuildingDecoration({ items, isRedesigned }: INewbuildingDecorationProps) {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['header']}>
        {isRedesigned ? (
          <ArticleHeading1 as="h2">Другие квартиры с отделкой в этом жк</ArticleHeading1>
        ) : (
          <InlineText1 as="h3" fontWeight="bold">
            Другие квартиры с отделкой в этом жк
          </InlineText1>
        )}
      </div>

      <div className={cx(styles['container'])}>{items}</div>
    </div>
  );
}
